import script from "./RevenueStatisticsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueStatisticsNew.vue?vue&type=script&setup=true&lang=js"

import "./RevenueStatisticsNew.vue?vue&type=style&index=0&id=d1d1becc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1d1becc"]])

export default __exports__